import { memo, useEffect, useMemo, useState } from 'react';
import {Nav, NavItem, NavLink} from 'reactstrap';
import { useLocation, useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import { isFeatureEnabledForActiveModule } from 'src/helpers/module_helper';
import useMailboxRoleAccess from 'src/modules/mailer/hooks/useMailboxRoleAccess';
import UserUtils from 'src/services/utils/UserUtils';
const Tabs = memo(({
    t,
    user
}) => {
    const [activeTab, setActiveTab] = useState("");
    const history = useHistory();
    const location = useLocation();
    const { canOpenSettings } = useMailboxRoleAccess();

    const isActiveTab = (currentTab, tab) => currentTab === tab;

    const tabsLinks = useMemo(() => {
        const links = [
            {
                key: "risk-customization",
                title: "Risk Customization"
            },
            {
                key: "routing",
                title: "Routing"
            },
            {
                key: "financial",
                title: "Financial Year"
            }
        ];

        if(isFeatureEnabledForActiveModule('mailer') && canOpenSettings) {
            links.push({
                key: "email-settings",
                title: "Email Settings",
            });
        }

        const userUtils = new UserUtils();
        const canManageConfluence = userUtils.isAnalystAdmin(user) || userUtils.isPartner(user);

        if (isFeatureEnabledForActiveModule('confluence_setting') && canManageConfluence) {
            links.push({
                key: "confluence-settings",
                title: "Confluence Settings",
            });
        }

        return links;
    }, [canOpenSettings, user]);

    useEffect(() => {
        const tabKey = (new URLSearchParams(location.search)).get('tab');
        const tab = tabsLinks.find((tab) => tab.key === tabKey);
        
        if(!tab) {
            history.push({
                search: '?tab=risk-customization'
            });
        }
        else {
            setActiveTab(tab.key);
        }
    }, [ 
        location.search,
        tabsLinks,
        history
    ]);

    return (
        <div style={{
            backgroundColor: '#D1D2D6',
        }}>
            <Nav tabs className="custom-style-1">
                {
                    tabsLinks.map((link) => {
                        return (
                            <NavItem className={isActiveTab(activeTab, link.key) ? 'active': ''} key={link.key}>
                                <NavLink className={isActiveTab(activeTab, link.key) ? 'active': ''}
                                    onClick={() => history.push({
                                        search : '?tab=' + link.key
                                    })}>
                                    {t(link.title)}
                                </NavLink>
                            </NavItem>
                        )
                    })
                }
            </Nav>
        </div>
	);
});

const mapStatetoProps = (state) => {
	const App = state.App;
	const { token } = state.Login;
	return {
		token,
		App,
        user: state.Login.user
	};
};


export default withNamespaces()(
  withRouter(connect(mapStatetoProps)(Tabs))
);
